import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card, Row, Col, Badge } from 'react-bootstrap';
import FalconCardHeader from '../../../common/FalconCardHeader';

const ProfileStats = ({ user }) => {
  if (!user) return null;

  const getStatusColor = (isActive) => {
    return isActive ? 'success' : 'danger';
  };

  const getStatusText = (isActive) => {
    return isActive ? 'Activo' : 'Inactivo';
  };

  const calculateAccountAge = (createdAt) => {
    const now = new Date();
    const diffTime = Math.abs(now.getTime() - new Date(createdAt).getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays < 30) {
      return `${diffDays} días`;
    } else if (diffDays < 365) {
      const months = Math.floor(diffDays / 30);
      return `${months} ${months === 1 ? 'mes' : 'meses'}`;
    } else {
      const years = Math.floor(diffDays / 365);
      const remainingMonths = Math.floor((diffDays % 365) / 30);
      return `${years} ${years === 1 ? 'año' : 'años'}${remainingMonths > 0 ? ` y ${remainingMonths} meses` : ''}`;
    }
  };

  const isAdmin = user.roles?.some(role => ['admin', 'ADMIN'].includes(role.name)) || false;

  return (
    <Card className="mb-3">
      <FalconCardHeader title="Estadísticas de Cuenta" />

      <Card.Body className="bg-body-tertiary">
        <Row className="g-3">
          {/* Estado de la cuenta */}
          <Col xs={12}>
            <div className="d-flex justify-content-between align-items-center p-3 bg-white rounded">
              <div>
                <FontAwesomeIcon icon="user-check" className="me-2 text-muted" />
                <span className="fw-semibold">Estado</span>
              </div>
              <Badge bg={getStatusColor(user.isActive)} className="fs-10">
                {getStatusText(user.isActive)}
              </Badge>
            </div>
          </Col>

          {/* Antigüedad de la cuenta */}
          <Col xs={12}>
            <div className="d-flex justify-content-between align-items-center p-3 bg-white rounded">
              <div>
                <FontAwesomeIcon icon="calendar-alt" className="me-2 text-primary" />
                <span className="fw-semibold">Antigüedad</span>
              </div>
              <span className="text-900">{calculateAccountAge(user.createdAt)}</span>
            </div>
          </Col>

          {/* Roles asignados */}
          <Col xs={12}>
            <div className="d-flex justify-content-between align-items-center p-3 bg-white rounded">
              <div>
                <FontAwesomeIcon icon="user-shield" className="me-2 text-warning" />
                <span className="fw-semibold">Roles</span>
              </div>
              <Badge bg="warning" text="dark" className="fs-10">
                {user.roles?.length || 0}
              </Badge>
            </div>
          </Col>

          {/* Áreas de negocio */}
          <Col xs={12}>
            <div className="d-flex justify-content-between align-items-center p-3 bg-white rounded">
              <div>
                <FontAwesomeIcon icon="building" className="me-2 text-info" />
                <span className="fw-semibold">Departamentos</span>
              </div>
              <Badge bg="info" className="fs-10">
                {user.businessAreas?.length || 0}
              </Badge>
            </div>
          </Col>

          {/* Privilegios especiales */}
          {(isAdmin || user.isSuperAdmin) && (
            <Col xs={12}>
              <div className="p-3 bg-gradient-primary text-white rounded">
                <div className="text-center">
                  <FontAwesomeIcon 
                    icon={user.isSuperAdmin ? "crown" : "shield-alt"} 
                    className="mb-2" 
                    size="lg" 
                  />
                  <h6 className="mb-1 text-white">
                    {user.isSuperAdmin ? 'Super Administrador' : 'Administrador'}
                  </h6>
                  <small className="text-white-50">
                    {user.isSuperAdmin 
                      ? 'Acceso completo al sistema'
                      : 'Permisos administrativos'
                    }
                  </small>
                </div>
              </div>
            </Col>
          )}
        </Row>

        {/* Información adicional */}
        <div className="mt-4 pt-3 border-top">
          <h6 className="text-muted mb-3">
            <FontAwesomeIcon icon="info-circle" className="me-1" />
            Información Adicional
          </h6>
          
          <div className="small text-muted">
            <div className="d-flex justify-content-between mb-2">
              <span>ID de Usuario:</span>
              <span className="text-900">#{user.id}</span>
            </div>
            <div className="d-flex justify-content-between mb-2">
              <span>Nombre de Usuario:</span>
              <span className="text-900">@{user.username}</span>
            </div>
            {user.company && (
              <div className="d-flex justify-content-between">
                <span>Empresa:</span>
                <span className="text-900">{user.company.name}</span>
              </div>
            )}
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default ProfileStats; 